import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.filter.js";
import "core-js/modules/es.iterator.for-each.js";
import "core-js/modules/es.iterator.map.js";
import "core-js/modules/es.json.parse.js";
import "core-js/modules/es.json.stringify.js";
import Cookies from "js-cookie";
// cookie保存的天数
// import config from "@/config";
// const { cookieExpires } = config;
import _ from "lodash";
import store from "store2";
export const TOKEN_KEY = "iam_cookie";
export const setToken = () => {
  // Cookies.set(TOKEN_KEY, token, { expires: cookieExpires || 1 });
};
/**
 * 读取同名 cookie 的所有值。
 * 历史原因 isLogin 存在两份变体：前端 js-cookie 写入的 host-only 变体 +
 * 后端 Set-Cookie 带 Domain 写入的域变体。重复名时 js-cookie 的读取结果
 * 依赖浏览器存储顺序（随用户历史变化），导致登录态判定不稳定。
 */
export const getCookieValues = name => {
  return document.cookie.split("; ").filter(Boolean).map(item => {
    const index = item.indexOf("=");
    return [item.slice(0, index), item.slice(index + 1)];
  }).filter(([key]) => key === name).map(([, value]) => value);
};

/**
 * 删除同名 cookie 的所有变体：
 * - host-only 变体（前端 js-cookie 默认写入）
 * - domain 变体（后端 Set-Cookie: Domain=<host> 写入）
 */
export const clearCookieAllVariants = name => {
  Cookies.remove(name);
  Cookies.remove(name, {
    domain: window.location.hostname
  });
};
export const setLogin = state => {
  // 未登录/登出：清除所有变体而不是写入 false，
  // 避免与后端写入的 isLogin=true（域变体）共存后读取结果随顺序变化。
  if (state !== true && state !== "true") {
    return clearCookieAllVariants("isLogin");
  }
  return Cookies.set("isLogin", "true");
};
export const getLogin = () => {
  // 任一变体为 true 即视为已登录，读取结果与 cookie 顺序无关
  return getCookieValues("isLogin").includes("true");
};
export const getToken = () => {
  const token = Cookies.get(TOKEN_KEY);
  if (token) return token;else return false;
};
function isJson(str) {
  if (typeof str !== "string") return false;
  try {
    JSON.parse(str);
    return true;
  } catch (e) {
    return false;
  }
}
export const getMFAConfigs = () => {
  const mfaSettingsStr = localStorage.getItem("mfaSettings");
  return mfaSettingsStr && isJson(mfaSettingsStr) ? JSON.parse(mfaSettingsStr) : {
    securityModel: "",
    effectiveScope: ""
  };
};
export const getPersonConfig = () => {
  const personalConfig = localStorage.getItem("personalConfig");
  return personalConfig && isJson(personalConfig) ? JSON.parse(personalConfig) : {
    bound: false,
    notified: false,
    qrcode: "",
    state: ""
  };
};
export const getSessionId = () => {
  return Cookies.get("JSESSIONID");
};
export const setUnitNumber = (unitTree = []) => {
  let num = 0;
  num = unitTree.length;
  let change = arr => {
    arr.forEach(v => {
      let childrenNum = v.children ? v.children.length : 0;
      num += childrenNum;
      if (v.children && v.children.length > 0) {
        change(v.children);
      }
    });
  };
  change(unitTree);
  Cookies.set("unitNumber", num);
};
export const getUnitNumber = () => {
  return Cookies.get("unitNumber");
};
export const noAuth = to => {
  return _.has(to.meta, "auth") && !to.meta.auth;
};
export const saveLocalUser = userInfo => {
  store.set("userInfo", userInfo);
};
export const setLocalWx = wx => {
  localStorage.setItem("wx", JSON.stringify(wx));
};
export const getLocalWx = () => {
  let wx = localStorage.getItem("wx");
  if (wx && isJson(wx)) {
    return JSON.parse(wx);
  } else {
    return {};
  }
};
export const clearLocalWx = () => {
  localStorage.removeItem("wx");
};
export const getAccountType = () => {
  return store.get("accountType");
};
export const setPasswordType = passwordType => {
  store.set("passwordType", passwordType);
};
export const getPasswordType = () => {
  return store.get("passwordType");
};